import React, { useState, useEffect } from "react";
import api from "../../../api/api";
import { toast } from "react-toastify";
import LinkModal from "./LinkModal";

const ImpLinkList = () => {

  const [displayLink, setDisplayLink] = useState([]);
  const [deleteResp, setDeleteResp] = useState(false);
  const [ linkId, setLinkId] = useState(0)
  const [viewMore, setViewMore] = useState(true)


  useEffect(() => {
    api
      .get("/info/important-links/")
      .then((response) => {
        setDisplayLink(response.data);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  }, [deleteResp]);


  const handleData = (id) => {
    // alert(id)
    api
      .delete(`/info/important-links/${id}/`)
      .then((response) => {
        setDeleteResp(!deleteResp);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  
  const handleSearch = (e) => {
    api.get(`/info/important-links/?search=${e.target.value}`)
    .then(response=> {
      setDisplayLink(response.data)
    }).catch(error=> {
      
    })
  }



  return (
    <div>
      <div className="w-full justify-center flex  ">
        <div className=" w-[90%]  mt-10 ">
          <div className="flex  justify-center">
            <h1 className="text-primary-red underline mt-2 text-center text-3xl font-bold lg:!mt-6">
              Create Important Link List 
            </h1>
          </div>
          <div className="flex flex-wrap gap-2 justify-between mt-5">
            <div className="rounded-full px-8 border border-3 border-red-600">
              <input
                type="text"
                onChange={(e)=> handleSearch(e)}
                className="outline-none"
                placeholder="Search by Link Name"
              />
            </div>
            <div className="rounded-full px-8 border border-3 border-red-600">
              <input
                type="text"
                className="outline-none"
                onChange={(e)=> handleSearch(e)}
                placeholder="Search by Link Category"
              />
            </div>
          </div>
          <div className="overflow-x-auto w-full">
          <table className="border-primary-blue  w-full border mt-5 text-center">
            <thead className="font-Bree bg-primary-red text-lg font-bold">
              <tr className="">
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  SN.
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Link Name
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Link Category
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Link Details
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Link
                </th>

                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Action
                </th>
              </tr>
            </thead>

            <tbody className="font-Acme">
              {displayLink.length < 1 && (
                <h1 className="w-full text-center">NO data to show </h1>
              )}
              {displayLink.slice(0, `${viewMore ? 10 : displayLink.length}`)
              .map((item, i) => (
                <tr key={i} className="border-primary-blue border-2  bg-white">
                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {i + 1}
                  </td>
                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {item.title}
                  </td>
                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {item.category}
                  </td>
                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {item.details}
                  </td>
                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {item.link}
                  </td>
                  <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                    <div className="flex gap-2">
                   
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#LinkModalDemo"
                        className="bg-primary-green rounded-full p-1 px-2 text-white"
                        onClick={() => {
                          setLinkId(item.id);
                        }}
                      >
                        View/ Edit
                      </button>

                      <LinkModal LinkId={linkId} setDeleteResp={setDeleteResp} />


                      {/* <button
                        className="bg-primary-red rounded-full p-1 px-2 text-white"
                        onClick={() => {
                          handleData(item.id);
                        }}
                      >
                        Delete
                      </button> */}
                      <button
                        className="bg-primary-red rounded-full p-1 px-2 text-white"
                        data-bs-toggle="modal"
                        data-bs-target="#DeleteLinkModalDemo"
                      >
                        Delete
                      </button>

                      {/* Delete Dialog Modal */}
                      <div
                        className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
                        id="DeleteLinkModalDemo"
                        tabIndex={-1}
                        aria-labelledby="exampleModalLabel"
                        aria-modal="true"
                        role="dialog"
                      >
                        <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
                          <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                            <div className="flex justify-end">
                              <svg
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                className="text-primary-blue h-8 w-8"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                role="img"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
                                />
                              </svg>
                            </div>
                            <div className="modal-header rounded-t-md  border-gray-200 text-2xl text-">
                              Are you sure want to Delete Link ?
                            </div>
                            <div className="flex justify-center gap-2 my-3">
                              <div data-bs-dismiss="modal"
                                aria-label="Close"
                                className="bg-red-600 text-white rounded-2xl p-2 cursor-pointer " onClick={() => {
                                  handleData(item.id);
                                }}>Delete</div>

                              <div
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            
                              >

                                <div className="bg-red-600 text-white rounded-2xl p-2 cursor-pointer ">Cancel</div>
                              
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      {/* </a> */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          <div className="mt-5 flex items-center justify-end gap-10">
            <div className="bg-primary-green font-Berkshire rounded-md px-3 py-2  text-white">
              <a href="">Print List</a>
            </div>
            <div className="bg-primary-blue rounded-md px-3 py-2  text-white">
            {viewMore ? <button onClick={() => setViewMore(false)}>View More</button> :
                        <button onClick={()=> setViewMore(true)}>View Less</button>
                    }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpLinkList;
